import { getCurrentCompanyConfig } from '../config/companies';

export function setDynamicFavicon(): void {
  const config = getCurrentCompanyConfig();


  // Update favicon link
  const favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;
  if (favicon) {
    favicon.href = config.favicon;
  } else {
    // Create favicon link if it doesn't exist
    const link = document.createElement('link');
    link.rel = 'icon';
    link.href = config.favicon;
    document.head.appendChild(link);
  }
}
